import styled from 'styled-components';

export const ReturnModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
`;

export const ModalContainer = styled.div`
    background: white;
    padding: 20px;
    border-radius: 8px;
    max-width: 600px;
    width: 100%;
    height: auto;
    max-height: 600px;
    justify-content: center;
    align-items: middle;
    display: flex;
    margin-top: 150px;
    flex-direction: column;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
`;

export const ModalHeader = styled.h2`
    margin: 0;
    color: #c2b280;
    text-align: center;
    margin-bottom: 100px;
`;

export const ModalBody = styled.div`
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    justify-content: flex-end;
`;

export const ModalFormLabel = styled.label`
  margin-bottom: 8px;
  font-size: 18px;
  font-weight: bold;
  color: gray; //#500000;
`;

export const ModalForm = styled.input`
  padding: 16px 16px;
  margin-bottom: 32px;
  border-radius: 2px;
  display: flex;
  font-size: 16px;
  font-weight: bold;
  &:focus {
    outline: none;
    border: 2px solid #c2b280
  }
`;

export const ModalTextArea = styled.textarea`
  padding: 16px 16px;
  margin-bottom: 24px;
  border-radius: 2px;
  border: none;
  min-height: 120px;
  max-width: 100%;
  max-height: 420px;


  &:focus {
    outline: none;
    border: 2px solid #c2b280
  }
`;

export const ModalFooter = styled.div`
    display: flex;
    justify-content: flex-end;
    align-self: center;
`;

export const ModalCloseButton = styled.button`
  border-radius: 50px;
  background: none;
  white-space: nowrap;
  padding: 2px 8px;
  color: #c2b280;
  font-size: 20px;
  outline: none;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  text-align: center;
  margin:2px;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: #fff;
    color: #c2b280;
  }
`;

export const ModalButton = styled.button`
  border-radius: 50px;
  background: #c2b280;
  white-space: nowrap;
  padding: 2px 8px;
  color: #ffffff;
  font-size: 20px;
  outline: none;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  text-align: center;
  margin:2px;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: #fff;
    color: #c2b280;
  }
`;
